/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Parties_Display_NameInputs */

const cs_parties_display_name = /** @type {(inputs: Parties_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazované jméno`)
};

const en_parties_display_name = /** @type {(inputs: Parties_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display name`)
};

/**
* | output |
* | --- |
* | "Display name" |
*
* @param {Parties_Display_NameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const parties_display_name = /** @type {((inputs?: Parties_Display_NameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Parties_Display_NameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_parties_display_name(inputs)
	return cs_parties_display_name(inputs)
});